var mapStyles = [];

module.exports = mapStyles;